(function () {

  function getThreshold() {
    var el = document.getElementById('cart-free-shipping');
    return el ? parseInt(el.dataset.threshold, 10) : 0;
  }

  function formatMoney(cents) {
    var container = document.getElementById('cart-free-shipping');
    var format = (container && container.dataset.moneyFormat)
      || (window.shopSettings && window.shopSettings.moneyFormat)
      || '${{amount}}';

    var value = (cents / 100).toFixed(2);
    var valueNoDecimals = Math.round(cents / 100);

    return format
      .replace('{{amount}}', value)
      .replace('{{amount_no_decimals}}', valueNoDecimals)
      .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', valueNoDecimals);
  }

  function updateFreeShipping(cartData) {
    var container = document.getElementById('cart-free-shipping');
    var threshold = getThreshold();

    if (!container || !threshold || !cartData) return;

    var total = cartData.total_price !== undefined ? cartData.total_price : null;
    if (total === null || total <= 0) return;

    var hasSubscription = (cartData.items || []).some(function (item) {
      return !!item.selling_plan_allocation;
    });

    var unlocked = hasSubscription || total >= threshold;
    var html = '';

    if (unlocked) {
      html =
        '<p class="cart-free-shipping__message cart-free-shipping__message--unlocked">' +
        "You've unlocked <strong>free shipping</strong>!" +
        '</p>' +
        '<div class="cart-free-shipping__bar">' +
        '<div class="cart-free-shipping__bar-fill" style="width:100%;"></div>' +
        '</div>';
    } else {
      var remaining = threshold - total;
      var progress = Math.min(Math.round((total / threshold) * 100), 100);
      html =
        '<p class="cart-free-shipping__message cart-free-shipping__message--progress">' +
        "You're <strong>" + formatMoney(remaining) + "</strong> away from free shipping." +
        '</p>' +
        '<div class="cart-free-shipping__bar">' +
        '<div class="cart-free-shipping__bar-fill" style="width:' + progress + '%;"></div>' +
        '</div>';
    }

    container.innerHTML = html;
  }

  function patchCartForm() {
    var CartFormClass = customElements.get('cart-form');
    if (!CartFormClass) return;

    // Patch updateByKey for free shipping updates
    var originalUpdateByKey = CartFormClass.prototype.updateByKey;
    CartFormClass.prototype.updateByKey = function (data) {
      originalUpdateByKey.call(this, data);
      if (data.total_price !== undefined) {
        updateFreeShipping(data);
      } else {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(updateFreeShipping);
      }
    };

    // Patch getCart to use a stable URL and guarantee setLoading(false)
    CartFormClass.prototype.getCart = function () {
      var self = this;
      self.setLoading(true);
      return fetch('/cart?section_id=cart-body', {
        method: 'GET',
        headers: { 'Cache-Control': 'no-store', 'Vary': '*' }
      })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var cartForm = parsed.querySelector('cart-form');
          if (!cartForm) {
            self.setLoading(false);
            return Promise.resolve();
          }
          self.innerHTML = cartForm.innerHTML;
          var itemCount = self.querySelector('.js-item-count');
          self.updateByKey({ item_count: itemCount ? itemCount.textContent : 0 });
          self.setLoading(false);
          return Promise.resolve();
        })
        .catch(function () {
          self.setLoading(false);
        });
    };

    // Patch update to catch the early return bug when a line item
    // is decremented to 0 while other items remain in the cart
    var originalUpdate = CartFormClass.prototype.update;
    CartFormClass.prototype.update = function (payload, key) {
      var self = this;
      self.setLoading(true);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: payload.updates })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count === 0) {
            self.getCart();
            return;
          }
          // Check if the keyed item was removed (decremented to 0)
          var keyedItem = key ? cart.items.find(function (i) { return i.key === key; }) : true;
          if (!keyedItem) {
            // Item was zeroed out but cart still has other items
            // Full re-render is the safest path
            self.getCart();
            return;
          }
          // Normal update path
          self.updateByKey(cart);
          if (key) {
            var priceEl = self.querySelector('[data-line-price="' + key + '"]');
            if (priceEl) {
              var item = cart.items.find(function (i) { return i.key === key; });
              if (item) priceEl.textContent = formatMoney(item.line_price);
            }
          }
          self.setLoading(false);
        })
        .catch(function () {
          self.setLoading(false);
        });
    };
  }

  if (customElements.get('cart-form')) {
    patchCartForm();
  } else {
    customElements.whenDefined('cart-form').then(patchCartForm);
  }
})();